<template>
  <div class="image-uploader">
    <!-- 上传区域 -->
    <div class="upload-area" 
         :class="{ 'has-image': imageUrl }"
         @drop.prevent="handleDrop"
         @click="upload"
         @dragover.prevent>
      
      <!-- 预览图片 -->
      <div v-if="imageUrl" class="preview">
        <img :src="imageUrl" alt="预览图">
        <div class="image-actions">
          <button @click.stop="removeImage" class="delete-btn">删除</button>
        </div>
      </div>

      <!-- 上传按钮和提示 -->
      <div v-else class="upload-content">
        <i class="upload-icon">+</i>
        <div class="upload-text">
          <p>点击或拖拽图片上传</p>
          <p class="size-tip">要求：本人近期2寸正面免冠彩色头像照片，规格413像素（宽）×626像素（高），分辨率350dpi；颜色模式24位RGB真彩色；格式JPG或JEPG，大小20K－100K；照片背景为红色，要求人像清晰，神态自然，无明显畸变。   </p>
          <!-- <p class="format-tip">支持格式：PNG、JPG、JPEG</p>
          <p class="size-limit">文件大小不超过 {{ maxSize }}MB</p> -->
        </div>
      </div>

      <!-- 隐藏的文件输入框 -->
      <input
        type="file"
        ref="fileInput"
        class="file-input"
        accept="image/*"
        @change="handleFileChange"
      >
    </div>

    <!-- 错误提示 -->
    <div v-if="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
    <button v-if="imageUrl&&imageUrl.indexOf('http')!==0"  @click="sure">确认上传</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ImageUploader',
  props: {
    // 推荐尺寸，格式如 "800x600"
    recommendSize: {
      type: String,
      default: '260x390'
    },
    // 最大文件大小（MB）
    maxSize: {
      type: Number,
      default: 1
    }
  },
  computed: mapState([
        'userInfo'
    ]),
  data() {
    return {
      imageUrl: '',
      errorMessage: '',
      file: ''
    }
  },
  mounted(){
    if(this.userInfo.avatar){
      this.imageUrl = this.userInfo.avatar
    }
  },
  methods: {
    async sure(){
        const formData = new FormData();
        formData.append('file', this.file);
        const res = await this.$http.post('/api/common/upload',formData)
        
        if(res.fullurl){
            this.$http.post('/api/user/profile',{
                avatar: res.url,
                bio:''
            }).then(res2 => {
              console.log(res,res2,'res2')
                this.$message.success('上传成功')
                this.$emit('upload-success', res.fullurl)
            })
        }
    },
    handleFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.validateAndUpload(file)
      }
    },
    upload(){
        this.$refs.fileInput.click()
    },
    handleDrop(e) {
      const file = e.dataTransfer.files[0]
      if (file) {
        this.validateAndUpload(file)
      }
    },
    validateAndUpload(file) {
      // 验证文件类型
      if (!file.type.includes('image/')) {
        this.errorMessage = '请上传图片文件'
        return
      }

      // 验证文件大小
    //   if (file.size > this.maxSize * 1024 * 1024) {
    //     this.errorMessage = `图片大小不能超过 ${this.maxSize}MB`
    //     return
    //   }

      // 验证图片尺寸
      const img = new Image()
      img.src = URL.createObjectURL(file)
      img.onload = () => {
        // const [recommendWidth, recommendHeight] = this.recommendSize.split('x').map(Number)
        
        this.errorMessage = ''
        this.imageUrl = URL.createObjectURL(file)
        this.file = file
      }
    },
    removeImage() {
      this.imageUrl = ''
      this.errorMessage = ''
      this.$refs.fileInput.value = ''
      this.$emit('remove-image')
    }
  }
}
</script>

<style scoped>
.image-uploader {
  width: 100%;
  max-width: 400px;
  margin: auto;
  padding-top: 80px;
}

.upload-area {
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.upload-area:hover {
  border-color: #6696ff;
}

.upload-area.has-image {
  border-style: solid;
}

.upload-icon {
  font-size: 28px;
  color: #8c939d;
  margin-bottom: 10px;
}

.upload-text {
  color: #606266;
}

.size-tip {
  color: #6696ff;
  margin: 8px 0;
}

.format-tip, .size-limit {
  color: #909399;
  font-size: 12px;
  margin: 4px 0;
}

.file-input {
  display: none;
}

.preview {
  position: relative;
}

.preview img {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
}

.image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.preview:hover .image-actions {
  opacity: 1;
}

.delete-btn {
  padding: 6px 12px;
  background: #f56c6c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 8px;
}
button {
  padding: 10px 20px;
  background-color: #285492;
  color: white;
  border: none;
  cursor: pointer;
  margin: auto;
  display: block;
  margin-top: 20px !important;
}

button:hover {
  background-color: #0056b3;
}
</style>